import Vue from 'vue';
import VueMoment from 'vue-moment';
import moment from 'moment';
import Vue2Filters from 'vue2-filters';
// import axios from 'axios';
import App from './App.vue';
import './registerServiceWorker';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import { Auth } from './plugins/Auth';
import { createProvider } from './vue-apollo';
import Http from './services/Http';
import Mixin from './helpers/Mixin';
import 'core-js/stable'; // only stable feature also is possible with only `core-js`
import 'regenerator-runtime/runtime'; // To ensure that regeneratorRuntime is defined globally
import './helpers/Instances';
import '@/assets/css/overwrite.scss';

require('moment/locale/es');

Vue.config.productionTip = false;

// Vue.use(axios);
Vue.use(Vue2Filters);
Vue.mixin(Mixin);
Vue.use(Auth);
Vue.use(VueMoment, {
  moment,
});

new Vue({
  router,
  store,
  vuetify,
  http: Http,
  apolloProvider: createProvider(),
  render: (h) => h(App),
}).$mount('#app');
